var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Registrants',_vm._g(_vm._b({},'Registrants',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }